import { render } from "./BlockEditor.vue?vue&type=template&id=fb276244&scoped=true"
import script from "./BlockEditor.vue?vue&type=script&lang=js"
export * from "./BlockEditor.vue?vue&type=script&lang=js"

import "./BlockEditor.vue?vue&type=style&index=0&id=fb276244&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fb276244"

export default script